module.exports = __webpack_public_path__ + "static/instagram-icon-acd98a66ea763e2f206b7c3e2d49f76c.png";